import { Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { InputTableFilter, RadioTableFilter, TableChip, TableFilterConfig } from '@shared';
import { TableFilterType } from '../../../../../shared/components/table-filter-menu';
import { getChipData } from '../../../../../shared/components/table-filter-menu/table-filter-menu.helpers';

export const ProductBalancesArticleFilter: InputTableFilter = {
  title: 'Артикул',
  controlName: 'article',
  type: TableFilterType.Input,
  testId: 'inputFilter',
  initialValue: '',
  apiFieldName: 'ArticleList',
  validators: [Validators.minLength(1), Validators.maxLength(40)],
  errors: {
    maxlength: 'Максимальна довжина 40 символів',
    minlength: 'Введіть, будь ласка, повний артикул',
  },
  placeholder: 'Введіть артикул',
  hotFilter: {
    type: TableFilterType.Input,
    quickButtonText: 'Артикул',
    overlayTitle: 'Артикул',
    overlayButtonText: 'Знайти у залишках',
    order: 1,
  },
  applyTrim: true,
  chipData: {
    content: (value) => `Артикул: ${value}`,
  },
};

export const ProductBalancesStatusFilter: RadioTableFilter = {
  title: 'Статус номенклатури',
  type: TableFilterType.Radio,
  testId: 'product-balances-status-filter',
  errors: {},
  placeholder: '',
  controlName: 'status',
  initialValue: 'Всі',
  apiFieldName: 'StatusList',
  validators: [],
  options: [
    { value: 'Всі', label: 'Всі', testId: 'Всі' },
    { value: 'Кондиція', label: 'Кондиція', testId: 'Кондиція' },
    { value: 'Втрачено', label: 'Втрачено', testId: 'Втрачено' },
    { value: 'Брак', label: 'Брак', testId: 'Брак' },
    { value: 'Брак приймання', label: 'Брак приймання', testId: 'Брак приймання' },
    { value: 'Брак складу', label: 'Брак складу', testId: 'Брак складу' },
    { value: 'Бій', label: 'Бій', testId: 'Бій' },
    { value: 'Переупаковка', label: 'Переупаковка', testId: 'Переупаковка' },
    { value: 'Прострочення', label: 'Прострочення', testId: 'Прострочення' },
    { value: 'Утилізація', label: 'Утилізація', testId: 'Утилізація' },
  ],
  hotFilter: {
    type: TableFilterType.Radio,
    quickButtonText: 'Статус номенклатури',
    overlayTitle: 'Статус номенклатури',
    overlayButtonText: 'Застосувати',
    order: 2,
  },
  chipData: {
    content: (value) => value,
  },
};

export const ProductBalancesFilterConfig: TableFilterConfig = {
  title: 'Фільтри',
  storageKey: 'product-balances-filters',
  buttons: {
    clearFilters: {
      text: 'Очистити все',
      testId: 'clearFiltersBtn',
      autofocus: false,
      class: 'btn',
    },
    applyFilters: {
      text: 'Застосувати фільтри',
      testId: 'applyFiltersBtn',
      color: 'primary' as ThemePalette,
    },
  },
  filterGroups: [
    {
      title: 'Дані про залишки',
      testId: 'group1',
      controlName: 'group1',
      expandedByDefault: true,
      filters: [ProductBalancesArticleFilter, ProductBalancesStatusFilter],
    },
  ],
};

export function getChips(filterGroups: Record<string, any>): TableChip[] {
  if (!filterGroups) {
    return [];
  }

  const { group1 } = filterGroups;

  return [
    ...getChipData('group1', ProductBalancesArticleFilter, group1?.article),
    ...getChipData('group1', ProductBalancesStatusFilter, group1?.status),
  ];
}
